import { useRef } from "react"
import { FormikProps } from "formik"
import { enqueueSnackbar } from "notistack"
import { useNavigate } from "react-router-dom"
import { MERCHANT_ADMIN_PAYMENT_LINKS_ROUTE, MERCHANT_ADMIN_ROUTE } from "../../../../../constants/routes"
import { StandardButton } from "../../../../../shared/components/buttons/StandardButton"
import { CreateUpdatePaymentLinkForm } from "../components/CreateUpdatePaymentLinkForm"
import { PageHeader } from "../../../../../shared/components/pageHeader/PageHeader"
import { LocalizedStrict } from "../../../../localization/components/AppLocalized"
import { Page } from "../../../../../shared/components/pageHeader/PageHeaderApi"
import { createPaymentLink, PaymentLinksQuery } from "../paymentLinksApi"
import { CreateUpdatePaymentLinkFormValues } from "../paymentLinksTypes"
import { useApiMutation } from "../../../../../core/api/useApiMutation"
import { prepareInitialValues } from "../helpers/prepareInitialValues"
import {
    Breadcrumb,
    BreadcrumbLink,
    StandardBreadcrumbs,
} from "../../../../../shared/components/links/StandardBreadcrumbs"
import { useDateTime } from "../../../../localization/useDateTime"
import { useMerchant } from "../../../../merchants/merchantHooks"

export function CreatePaymentLink() {
    const { merchantId } = useMerchant()
    const dateTimeFactory = useDateTime()
    const navigate = useNavigate()
    const formRef = useRef<FormikProps<CreateUpdatePaymentLinkFormValues>>(null)

    const handleSaveClick = () => {
        formRef.current?.submitForm()
    }

    const { mutate: callCreatePaymentLink } = useApiMutation(createPaymentLink, {
        async onSuccess(_, data, context) {
            await context.queryClient.invalidateQueries({ queryKey: [PaymentLinksQuery.LIST] })
            navigate(MERCHANT_ADMIN_PAYMENT_LINKS_ROUTE)
            if (!data.serviceResponse.displayMessage) return
            enqueueSnackbar({
                variant: "success",
                message: data?.serviceResponse.displayMessage,
            })
        },
    })

    return (
        <>
            <LocalizedStrict id="payment-links-create-page-header" attrs={{ title: true }}>
                <PageHeader
                    page={Page.MERCHANT_PAYMENT_LINK_CREATE}
                    title="Create payment link"
                    rightElement={
                        <LocalizedStrict id="payment-links-form-create-submit-button">
                            <StandardButton type="submit" onClick={handleSaveClick}>
                                Create
                            </StandardButton>
                        </LocalizedStrict>
                    }
                >
                    <StandardBreadcrumbs>
                        <LocalizedStrict id="merchant-nav-item-home">
                            <BreadcrumbLink to={MERCHANT_ADMIN_ROUTE}>Home</BreadcrumbLink>
                        </LocalizedStrict>
                        <LocalizedStrict id="merchant-nav-item-shops">
                            <Breadcrumb>Shops</Breadcrumb>
                        </LocalizedStrict>
                        <LocalizedStrict id="merchant-nav-item-payment-links">
                            <BreadcrumbLink to={MERCHANT_ADMIN_PAYMENT_LINKS_ROUTE}>Payment links</BreadcrumbLink>
                        </LocalizedStrict>
                        <LocalizedStrict id="payment-links-create-page">
                            <Breadcrumb>Create payment link</Breadcrumb>
                        </LocalizedStrict>
                    </StandardBreadcrumbs>
                </PageHeader>
            </LocalizedStrict>
            <CreateUpdatePaymentLinkForm
                ref={formRef}
                initialValues={prepareInitialValues(dateTimeFactory)}
                onSubmit={(data) => {
                    callCreatePaymentLink({
                        paymentLink: {
                            ...data,
                            merchant: {
                                id: merchantId,
                            },
                        },
                    })
                }}
            />
        </>
    )
}
